/*
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FmFlyoutModule, FmMenuModule, FmTriggerModule } from '@fleetmatics/ui.navbar';
import { TooltipModule } from '../../../projects/shared/src/lib/components/tooltip/tooltip.module';
import {
  FmSearchLightCategoryMenuComponent,
  FmSearchLightCategoryMenuOptionComponent,
  FmSearchLightCategoryResultsMenuComponent,
  FmSearchLightFabComponent,
  FmSearchLightFabInputComponent,
  FmSearchLightFormComponent,
  FmSearchLightInputComponent,
  FmSearchLightPanelComponent
} from './components';
import { FmSearchLightComponent } from './search-light.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    FmFlyoutModule,
    FmMenuModule,
    FmTriggerModule,
    MatIconModule,
    MatLegacyProgressSpinnerModule,
    MatLegacyTooltipModule,
    TooltipModule
  ],
  declarations: [
    FmSearchLightComponent,
    FmSearchLightFabComponent,
    FmSearchLightCategoryMenuComponent,
    FmSearchLightCategoryMenuOptionComponent,
    FmSearchLightCategoryResultsMenuComponent,
    FmSearchLightInputComponent,
    FmSearchLightFabInputComponent,
    FmSearchLightPanelComponent,
    FmSearchLightFormComponent
  ],
  exports: [FmSearchLightFormComponent, FmSearchLightFabComponent]
})
export class FmSearchLightModule {}
